import React from "react";
import { Group as StyledGroup } from "./styled";
import { Context } from "./context";
import { tToggleButtonCtxProps } from "./types";

type tProps = {
  className?: string;
  "aria-label"?: string;
  children: any;
} & tToggleButtonCtxProps;
const Group = (props: tProps) => {
  return (
    <StyledGroup className={props.className} aria-label={props["aria-label"]}>
      <Context.Provider
        value={{
          value: props.value,
          onChange: props.onChange,
        }}
      >
        {props.children}
      </Context.Provider>
    </StyledGroup>
  );
};

export default Group;
